export default "__VITE_ASSET__1pBEr26j__"